import React, { useState } from 'react';

import { useAccessGuard } from 'src/components/auth';
import { OptionsMenuItem, ReusableMenu } from 'src/components/index';
import { Apollo } from 'src/gql/generated';
import type { ReactSetStateAction } from 'src/types/general';

interface ContractTypesMenuProps {
  setDeleteDialogOpen: ReactSetStateAction<boolean>;
  setRenameDialogOpen: ReactSetStateAction<boolean>;
  showDelete: boolean;
}

export function ContractTypesMenu({
  setDeleteDialogOpen,
  setRenameDialogOpen,
  showDelete,
}: ContractTypesMenuProps): JSX.Element | null {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const handleOpen = useAccessGuard({
    callback: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) =>
      setAnchorEl(event.currentTarget),
    minRole: Apollo.OrgRole.Admin,
  });

  function closeHandler(): void {
    setAnchorEl(null);
  }

  function deleteHandler(): void {
    setDeleteDialogOpen(true);
    closeHandler();
  }

  function renameHandler(): void {
    setRenameDialogOpen(true);
    closeHandler();
  }

  return (
    <ReusableMenu anchorEl={anchorEl} handleClose={closeHandler} handleOpen={handleOpen}>
      <OptionsMenuItem clickHandler={renameHandler} text="Rename" />
      {showDelete && <OptionsMenuItem clickHandler={deleteHandler} text="Delete" />}
    </ReusableMenu>
  );
}
